import React from 'react';
import { useDispatch } from 'react-redux';
import { nuevoTrabajador } from '../../actions/trabajadoresActions';
import { verificarDniExistente, agregarRolAUsuario } from '../../actions/userActions';

const withRegistroTrabajador = WrappedComponent => props => {

  const dispatch = useDispatch();

  const handleNuevoTrabajador = async (datos) => {
    const { areas = [], ...resto } = datos
    const primaryArea = areas[0] || ''

    // Crear trabajador con el rol principal
    await dispatch(nuevoTrabajador({ ...resto, area: primaryArea }))

    // Agregar roles adicionales si seleccionó más de uno
    if (areas.length > 1) {
      const dniVerif = await dispatch(verificarDniExistente(String(datos.dni)))
      if (dniVerif && dniVerif.existe) {
        for (const rolId of areas.slice(1)) {
          await dispatch(agregarRolAUsuario(dniVerif.id_usuario, parseInt(rolId)))
        }
      }
    }
  }

  return (
    <WrappedComponent
      {...props}
      handleSubmitAction={handleNuevoTrabajador}
      areas={true}
    />
  );
}

export default withRegistroTrabajador;
